"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedItems = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../../../../..");
const tokens_1 = require("../../../../../styles/tokens");
const config_1 = require("../../config");
const hooks_1 = require("../../hooks");
const SelectInput_styles_1 = require("./SelectInput.styles");
const SelectedItems = ({ option, onRemoveCallback, }) => {
    const { selected = [], setSelected = () => [], disabled } = (0, hooks_1.useSelect)();
    const [hasHover, setHasHover] = (0, react_1.useState)(false);
    const removeSelectedItem = (option, event) => {
        event.stopPropagation();
        if (Array.isArray(selected)) {
            const filteredItems = selected.filter((o) => o.value !== option.value);
            setSelected(filteredItems);
            onRemoveCallback && onRemoveCallback(filteredItems);
        }
    };
    const removeHandler = (event) => {
        !disabled && removeSelectedItem(option, event);
    };
    const onMouseEnter = () => {
        setHasHover(true);
    };
    const onMouseLeave = () => {
        setHasHover(false);
    };
    return (react_1.default.createElement(SelectInput_styles_1.StyledSelectSelectedItem, { "data-testid": `select-item-${option.value}-badge`, "aria-disabled": disabled },
        react_1.default.createElement(__1.Flex, { alignItems: "flex-start" },
            react_1.default.createElement(__1.Item, null,
                react_1.default.createElement(SelectInput_styles_1.StyledSelectSelectedItemLabel, null, option.label)),
            react_1.default.createElement(__1.Item, null,
                react_1.default.createElement(SelectInput_styles_1.StyledSelectIconSmall, { "aria-label": "Remove", onClick: removeHandler, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
                    react_1.default.createElement(__1.Icon, { name: "Cross", title: "Remove", size: tokens_1.buttonInputFieldIconSizes[config_1.DIMENSIONS.SMALL]
                            .withText, colour: hasHover && !disabled ? "white" : "zinc" }))))));
};
exports.SelectedItems = SelectedItems;
//# sourceMappingURL=SelectedItems.js.map